let modalAbierto = localStorage.getItem("modalAbierto")

if (modalAbierto != 0){
$(function(){
  	$("#myModal").modal({backdrop: 'none', keyboard: true});
  
localStorage.setItem('modalAbierto', 0);
});

}else{}
/*

$('#myModal2').click(function() {
 $('#myModal2').fadeOut();
});
  

// Get the modal
var modal = document.getElementById("myModal1");

// Get the button that opens the modal
var btn = document.getElementById("myBtsn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal 

btn.onclick =function(){
  	modal.style.display = "block";

}

function activaModal(){
 
  let modalAbierto1 = localStorage.getItem("modalAbierto1")
  
  if (modalAbierto1 != 0){
$(function(){
  	
  modal.style.display = "block";
  
localStorage.setItem('modalAbierto1', 0);
});

}else{}
  
}





// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}
*/
  
